/**
 * One line for a failed request, from the server's error envelope (HttpErrorResponse.error.error: html[], message[],
 * data.reason) or the thrown error's own message. Each caller lists the parts it shows, in the order it prefers
 * (they differ on purpose: a place action's refusal reason is the useful part, a list's HTML message is). Tested in
 * api-errors.spec.ts.
 */

export type ErrorPart = 'html' | 'message' | 'reason' | 'thrown';

/** The order most of the Suburbs tool uses. */
export const HTML_FIRST: ErrorPart[] = ['html', 'message', 'thrown'];
/** A place being added by hand or reviewed: the server's refusal reason first. */
export const REASON_FIRST: ErrorPart[] = ['reason', 'html', 'message', 'thrown'];

export function apiErrorText(
  err: unknown,
  fallback: string,
  order: ErrorPart[] = HTML_FIRST
): string {
  const e: any = err;
  const body = e?.error?.error;
  const parts: Record<ErrorPart, () => string | undefined> = {
    html: () => body?.html?.join(' '),
    message: () => body?.message?.join(' '),
    reason: () => body?.data?.reason,
    thrown: () => e?.message,
  };
  for (const part of order) {
    const text = parts[part]();
    if (text) return text;
  }
  return fallback;
}

/** The server's error envelope itself (for ModalService.error), else whatever was thrown. */
export function apiErrorBody(err: unknown): unknown {
  return (err as any)?.error?.error || err;
}

/** A publish refused because website publishing isn't set up on this Conductor (local, or before the secrets). */
export function publishNotSetUp(err: unknown): boolean {
  return /not[_ ]configured/i.test(JSON.stringify((err as any)?.error ?? err ?? ''));
}
